'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showDiscountedPricingSelector = exports.isHSFXEligibleSelector = exports.allEligibleDiscountsSelector = exports.allPromotionsSelector = exports.merchSpecficPromotionEligibilitySelector = undefined;

var _underscore = require('underscore');

var _Promotions = require('self-service-api/constants/Promotions');

var _Terms = require('self-service-api/constants/Terms');

var merchSpecficPromotionEligibilitySelector = exports.merchSpecficPromotionEligibilitySelector = function merchSpecficPromotionEligibilitySelector(_ref, merchandiseId) {
  var promotions = _ref.promotions;

  var allPromotions = promotions.merchEligibleForDirectPromotions;

  return allPromotions ? allPromotions[merchandiseId] : {};
};

var allPromotionsSelector = exports.allPromotionsSelector = function allPromotionsSelector(_ref2) {
  var promotions = _ref2.promotions;

  return promotions;
};

// returns an array of all promotions keys with a discount that can be applied
var allEligibleDiscountsSelector = exports.allEligibleDiscountsSelector = function allEligibleDiscountsSelector(state) {
  var allPromotions = Object.values(state.promotions.merchEligibleForDirectPromotions || {});

  return (0, _underscore.uniq)(allPromotions.map(function (promotion) {
    return promotion.eligiblePromotion;
  }).filter(function (promotion) {
    return !!promotion && !promotion.includes(_Promotions.promotionKeys.NO_PROMOTION);
  }));
};

var isHSFXEligibleSelector = exports.isHSFXEligibleSelector = function isHSFXEligibleSelector(state) {
  var allPromotions = allEligibleDiscountsSelector(state);
  return allPromotions.includes(_Promotions.promotionKeys.HSFS_SEED) || allPromotions.includes(_Promotions.promotionKeys.HSFS_SERIES_A) || allPromotions.includes(_Promotions.promotionKeys.HSFX_ENTREPRENEUR);
};

var showDiscountedPricingSelector = exports.showDiscountedPricingSelector = function showDiscountedPricingSelector(state, merchandiseId, term) {
  var productPromotion = merchSpecficPromotionEligibilitySelector(state, merchandiseId);

  // Temporary special case here to show the discounted pricing
  // The term is monthly by default here; however the discount is
  // only annual since you can only buy Pro annually
  if (productPromotion && productPromotion.eligiblePromotion === 'MARKETING_BASIC_TO_PRO') {
    return true;
  }

  return !!(productPromotion && (productPromotion.monthlyDiscount && term === _Terms.MONTHLY || productPromotion.annualDiscount && term === _Terms.ANNUAL));
};


//////////////////
// WEBPACK FOOTER
// ./js/selectors/PromotionSelectors.js
// module id = 79
// module chunks = 3 4 5